var React = require('react');

function FacebookBlack (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.66895 0C3.42069 0 0 3.42068 0 7.66893V34.331C0 38.5793 3.42069 42 7.66895 42H22.1196V25.5806H17.7778V19.6691H22.1196V14.6186C22.1196 10.6507 24.6849 7.00743 30.5944 7.00743C32.987 7.00743 34.7563 7.23713 34.7563 7.23713L34.6172 12.7575C34.6172 12.7575 32.8128 12.7405 30.8438 12.7405C28.7127 12.7405 28.371 13.7223 28.371 15.3524V19.6691H34.7865L34.5069 25.5806H28.371V42H34.3311C38.5793 42 42 38.5793 42 34.3311V7.66897C42 3.42072 38.5793 4.19999e-05 34.3311 4.19999e-05H7.66891L7.66895 0Z","fill":"black"}));
}

FacebookBlack.defaultProps = {"width":"42","height":"42","viewBox":"0 0 42 42","fill":"none"};

module.exports = FacebookBlack;

FacebookBlack.default = FacebookBlack;
